import * as yup from 'yup';
import {
  nullableNumber,
  nullableNumberRequiredWith,
} from '../components/common/FormUtils';

export const luomuMaitotuotteidenValmistusSchema = yup.object().shape(
  {
    LuomumaitotuotteidenValmistusMaidot: nullableNumber,
    LuomumaitotuotteidenValmistusKermat: nullableNumber,
    LuomumaitotuotteidenValmistusHapatetutKermavalmisteet: nullableNumber,
    LuomumaitotuotteidenValmistusPiimat: nullableNumber,
    LuomumaitotuotteidenValmistusJogurtit: nullableNumber,
    LuomumaitotuotteidenValmistusViilit: nullableNumber,
    LuomumaitotuotteidenValmistusVoi: nullableNumber,
    LuomumaitotuotteidenValmistusRasvaseokset: nullableNumber,
    LuomumaitotuotteidenValmistusRasvaseoksetMaito: nullableNumberRequiredWith([
      'LuomumaitotuotteidenValmistusRasvaseokset',
    ]),
    LuomumaitotuotteidenValmistusJuusto: nullableNumber,
    LuomumaitotuotteidenValmistusMaitojauheet: nullableNumber,
    LuomumaitotuotteidenValmistusMuut: nullableNumber,
    EiLuomumaitotuotteidenValmistusta: yup.boolean(),
  },
  [
    [
      'LuomumaitotuotteidenValmistusRasvaseoksetMaito',
      'LuomumaitotuotteidenValmistusRasvaseokset',
    ],
  ],
);
